import React from 'react';

const X = (props) => (
  <svg width={18} height={17} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.813 8.626l-6.84 6.84 1.302 1.304 6.84-6.84 6.841 6.84 1.303-1.303-6.84-6.84 6.84-6.841L15.956.483l-6.84 6.84-6.84-6.84L.971 1.786l6.84 6.84z"
      fill="#2D2A26"
    />
  </svg>
);

export default X;
